<template>
  <div class="big mydialog">
    <div class="page_title">设置诊所</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="flex between" style="margin-bottom: 12px">
          <span style="font-size: 18px">已设置{{ totalNum }}家</span>
          <span>
            <el-button
              type="primary"
              style="width: 90px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('554') : false
              "
              @click="setClinic"
              >保存</el-button
            >
            <el-button style="width: 90px" plain @click="back">返回</el-button>
          </span>
        </div>
        <div style="text-align: left; margin-bottom: 10px">
          <span>诊所名称</span>
          <el-input
            v-model="hospital_name"
            style="width: 160px; margin: 0 20px 0 10px"
            @input="getList"
            clearable
          ></el-input>
          <span>诊所类型</span>
          <el-select
            v-model="org_type"
            placeholder="请选择"
            style="width: 160px; margin: 0 20px 0 10px"
            @change="getList"
            clearable
          >
            <el-option label="全部" :value="0"></el-option>
            <el-option
              v-for="item in org_type_list"
              :key="item.org_type"
              :label="item.org_type_name"
              :value="item.org_type"
            ></el-option>
          </el-select>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="getList"
            >查询</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column width="50">
              <template slot="header">
                <el-checkbox
                  v-model="checkAll"
                  @change="checkAllChange"
                  :indeterminate="isIndeterminate"
                ></el-checkbox>
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.checked"
                  @change="checkChange"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column
              prop="hospital_name"
              label="诊所名称"
            ></el-table-column>
            <el-table-column label="诊所类型">
              <template slot-scope="scope">
                <span v-if="scope.row.org_type == 1">综合医院</span>
                <span v-if="scope.row.org_type == 2">专科医院</span>
                <span v-if="scope.row.org_type == 3">街道卫生服务中心</span>
                <span v-if="scope.row.org_type == 4">社区卫生服务中心</span>
                <span v-if="scope.row.org_type == 5">乡镇卫生院</span>
                <span v-if="scope.row.org_type == 6">村卫生室</span>
                <span v-if="scope.row.org_type == 7">企业医院</span>
                <span v-if="scope.row.org_type == 8">门诊部</span>
                <span v-if="scope.row.org_type == 9">个体诊所</span>
                <span v-if="scope.row.org_type == 10">其他</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="所在地区"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import platform from "../../../api/platform";
export default {
  data() {
    return {
      totalNum: 0,
      tableData: [],
      checkAll: false,
      isIndeterminate: false,
      hospital_name: "",
      org_type: "",
      org_type_list: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: 1,
        pageNumber: 1000,
        hospital_name: this.hospital_name,
        org_type: this.org_type,
      };
      this.axios
        .post("platform/TraditionDrug/getTraditionDrugClinicList", data)
        .then((res) => {
          if (res.code == 0) {
            let a = 0;
            this.tableData = res.data.list.map((item) => {
              if (item.bool) {
                a += 1;
              }
              item.checked = item.bool ? true : false;
              return item;
            });
            this.totalNum = a;
            if (a < res.data.total && a) {
              this.isIndeterminate = true;
            }
            if (this.totalNum == res.data.total) {
              this.checkAll = true;
            }
          }
        });
    },

    //获取配置信息
    getConfig() {
      platform.getConfigList().then((res) => {
        if (res.code == 0) {
          this.org_type_list = res.data.org_type_list_clinic;
        }
      });
    },
    //全选
    checkAllChange(value) {
      this.isIndeterminate = false;
      if (value) {
        this.tableData.map((item) => {
          item.checked = true;
          return item;
        });
      } else {
        this.tableData.map((item) => {
          item.checked = false;
          return item;
        });
      }
    },
    //单选改变
    checkChange(value) {
      let a = 0;
      if (value) {
        this.tableData.map((item) => {
          if (!item.checked) {
            a = 1;
          }
        });
      } else {
        this.tableData.map((item) => {
          if (item.checked) {
            a = 1;
          }
        });
      }
      if (a) {
        this.isIndeterminate = true;
      } else {
        if (value) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
        this.isIndeterminate = false;
      }
    },
    //设置诊所
    setClinic() {
      if (!this.checkAll && !this.isIndeterminate) {
        this.$message.error("请先选择添加的诊所");
        return false;
      }
      let selectArr = [];
      this.tableData.map((item) => {
        if (item.checked) {
          selectArr.push(item.hospital_id);
        }
      });
      let data = {
        clinic_type: 2,
        clinic_id: selectArr.toString(),
      };
      this.axios
        .post("platform/TraditionDrug/saveTraditionDrugClinicInfo", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.getList();
          }
        });
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getConfig();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item {
    margin-right: 5px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    .itemtitle {
      display: inline-block;
      width: 80px;
      text-align: right;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.mydialog .el-dialog__body {
  padding: 0px !important;
}
</style>